module.exports = __webpack_public_path__ + "static/img/s80.64971abe.png";